var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-col", { attrs: { xs: "12" } }, [
        _vm._v(" " + _vm._s(_vm.label) + " "),
      ]),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-select", {
            attrs: {
              items: _vm.settingsTypes,
              fancy: "",
              label: _vm.$ct("setting-type"),
            },
            model: {
              value: _vm.value.Type,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Type", $$v)
              },
              expression: "value.Type",
            },
          }),
        ],
        1
      ),
      _vm.value.Type == "string"
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: { fancy: "", label: _vm.$ct("col-text") },
                model: {
                  value: _vm.value.Value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Value", $$v)
                  },
                  expression: "value.Value",
                },
              }),
            ],
            1
          )
        : _vm.value.Type == "value"
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-value-autocomplete", {
                attrs: {
                  "known-headers": _vm.knownHeaders,
                  fancy: "",
                  label: _vm.$ct("col-value"),
                },
                model: {
                  value: _vm.value.Value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Value", $$v)
                  },
                  expression: "value.Value",
                },
              }),
            ],
            1
          )
        : _vm.value.Type == "code"
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("div", { staticClass: "ml" }, [
                _vm._v(_vm._s(_vm.$ct("code"))),
              ]),
              _c("codemirror", {
                attrs: {
                  value: _vm.value.Value,
                  options: _vm.codeMirrorOptions,
                },
                on: {
                  input: function ($event) {
                    return _vm.onScriptInput($event)
                  },
                },
              }),
              _vm.scriptErrorMessage
                ? _c("app-error-message-box", [
                    _vm._v(" " + _vm._s(_vm.scriptErrorMessage) + " "),
                  ])
                : _vm._e(),
              _c("ul", { staticClass: "code-tips" }, [
                _c("li", [
                  _vm._v(_vm._s(_vm.$ct("use-variable-row-as-current-row"))),
                ]),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$ct("use-variable-current-row-as-current-row"))
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }